module.exports = __webpack_public_path__ + "static/media/Glasses_1.99ed9355.svg";